module.exports = __webpack_public_path__ + "images/f70c91d3547c54cccbc18ea039720c3e.gif";